module.exports = __webpack_public_path__ + "static/media/video.72ed5715.mp4";